import React from "react";
import { Modal, Typography, Flex, Card, Tag, Button, Divider, Space } from "antd";
import {
  ThunderboltOutlined,
  CheckCircleOutlined,
  RightOutlined,
  BulbOutlined,
} from "@ant-design/icons";

const { Title, Text, Paragraph } = Typography;

function AiSummaryModal({ visible, company, onClose }) {
  if (!company) return null;

  return (
    <Modal
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="close" type="primary" onClick={onClose}>
          Done
        </Button>,
      ]}
      width={680}
      title={
        <Flex align="center" gap={8}>
          <div
            style={{
              background: "linear-gradient(135deg, #2459d3, #7c3aed)",
              borderRadius: 8,
              padding: "4px 8px",
              color: "#fff",
              display: "flex",
              alignItems: "center",
            }}
          >
            <ThunderboltOutlined style={{ fontSize: 16 }} />
          </div>
          <Flex vertical>
            <Text style={{ fontSize: "0.75rem", color: "#64748b", textTransform: "uppercase", fontWeight: 700 }}>
              AI Intelligence Brief
            </Text>
            <Title level={4} style={{ margin: 0 }}>
              {company.name}
            </Title>
          </Flex>
        </Flex>
      }
    >
      <Flex vertical gap={16} style={{ marginTop: 16 }}>
        {/* Industry & Location Tags */}
        <Flex align="center" gap={8} wrap="wrap">
          <Tag color="blue">{company.category}</Tag>
          <Tag color="purple">{company.city}</Tag>
          <Tag color="cyan">{company.leadSet}</Tag>
        </Flex>

        {/* Executive Summary Card */}
        <Card
          bordered={false}
          style={{ background: "#f8fafc", borderRadius: 10 }}
          styles={{ body: { padding: 14 } }}
        >
          <Text strong style={{ display: "block", marginBottom: 6, color: "#1e293b" }}>
            Executive Overview
          </Text>
          <Paragraph style={{ margin: 0, color: "#475569", fontSize: "0.9rem", lineHeight: 1.6 }}>
            {company.aiSummary}
          </Paragraph>
        </Card>

        {/* AI Recommendations */}
        <div>
          <Flex align="center" gap={6} style={{ marginBottom: 8 }}>
            <BulbOutlined style={{ color: "#f59e0b" }} />
            <Text strong style={{ fontSize: "0.85rem", textTransform: "uppercase", color: "#64748b" }}>
              Suggested Next Steps
            </Text>
          </Flex>

          <Flex vertical gap={8}>
            <Flex align="start" gap={8} style={{ padding: "8px 12px", background: "#f0fdf4", borderRadius: 8 }}>
              <CheckCircleOutlined style={{ color: "#10b981", marginTop: 3 }} />
              <Text style={{ fontSize: "0.85rem", color: "#166534" }}>
                Pitch the automated Call Log Sync & Team Rep Dashboard package (est. deal size: ₹120,000/yr).
              </Text>
            </Flex>
            <Flex align="start" gap={8} style={{ padding: "8px 12px", background: "#eff6ff", borderRadius: 8 }}>
              <RightOutlined style={{ color: "#2459d3", marginTop: 3 }} />
              <Text style={{ fontSize: "0.85rem", color: "#1e40af" }}>
                Target Primary Contact: <b>{company.contacts[0]?.contactName}</b> ({company.contacts[0]?.designation}) for scheduling the technical pilot demo.
              </Text>
            </Flex>
          </Flex>
        </div>

        <Divider style={{ margin: "4px 0" }} />

        {/* Contact Rollup */}
        <Flex justify="space-between" align="center">
          <Text type="secondary" style={{ fontSize: "0.8rem" }}>
            Total Contacts Identified: <b>{company.contacts.length}</b>
          </Text>
          <Space>
            <Button size="small" type="dashed">
              Export AI Brief
            </Button>
          </Space>
        </Flex>
      </Flex>
    </Modal>
  );
}

export default AiSummaryModal;
